import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Layout } from "@/components/Layout";
import { initGA, trackPageView } from "@/lib/analytics";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Priorities from "@/pages/Priorities";
import GetInvolved from "@/pages/GetInvolved";
import Vote from "@/pages/Vote";
import Contact from "@/pages/Contact";
import Donate from "@/pages/Donate";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const RequireAdmin = ({ children }) => {
  const token = localStorage.getItem("satish_admin_token");
  return token ? children : <Navigate to="/admin" replace />;
};

const RouteTracker = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    trackPageView(pathname + window.location.search);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => { initGA(); }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <RouteTracker />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/priorities" element={<Priorities />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/vote" element={<Vote />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/donate" element={<Donate />} />
            <Route path="/privacy" element={<Legal />} />
            <Route path="/terms" element={<Legal />} />
          </Route>
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
